import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const COMMUNITY_ENDPOINTS = {
  V2: createEndpoints('v2', {
    COMMUNITIES: '/communities/',
    COMMUNITY: (id: number) => `/communities/${id}/`,
  }),
} as const;
